import { useState } from 'react'
import { ChevronDown, HelpCircle } from 'lucide-react'
import './LandingFAQ.css'

const faqs = [
  {
    q: 'Werden meine Chats auf euren Servern gespeichert?',
    a: 'Nein. Deine Chat-Datei wird ausschließlich für die PDF-Generierung verarbeitet und anschließend automatisch nach 30 Tagen gelöscht. Wir haben keinen Zugriff auf deine Nachrichteninhalte und geben sie nicht weiter.',
  },
  {
    q: 'Wie exportiere ich einen WhatsApp-Chat?',
    a: 'Öffne WhatsApp, gehe zum gewünschten Chat, tippe auf die drei Punkte (Menü) → "Mehr" → "Chat exportieren". Wähle "Mit Medien" und lade die ZIP-Datei hier hoch. Wir erledigen den Rest!',
  },
  {
    q: 'Funktioniert das mit iOS und Android?',
    a: 'Ja. ChatArchiv unterstützt Exporte von WhatsApp auf iPhone (iOS) und Android, inklusive der verschiedenen Datums- und Zeitformate beider Plattformen.',
  },
  {
    q: 'Was passiert mit meinen Dateien nach dem Kauf?',
    a: 'Das generierte PDF ist 30 Tage lang über deinen Download-Link abrufbar. Nach 30 Tagen werden alle Dateien automatisch von unseren Servern gelöscht.',
  },
  {
    q: 'Was tue ich, wenn mein Chat nicht erkannt wird?',
    a: 'Schreib uns an kontakt@chatarchiv.de — wir helfen dir bei ungewöhnlichen Exportformaten. Wir empfehlen den Chat als ZIP (nicht nur als TXT) zu exportieren, damit alle Medien enthalten sind.',
  },
]

export function LandingFAQ() {
  const [open, setOpen] = useState<number | null>(0)

  return (
    <section id="faq" className="landing-faq">
      <div className="faq-header">
        <h2 className="faq-title">Häufige Fragen</h2>
        <p className="faq-sub">Sicherheit und Datenschutz stehen an erster Stelle</p>
      </div>
      <div className="faq-list">
        {faqs.map((faq, i) => (
          <div key={i} className={`faq-item ${open === i ? 'open' : ''}`}>
            <button className="faq-question" onClick={() => setOpen(open === i ? null : i)}>
              <div className="faq-q-inner">
                <HelpCircle size={18} className="faq-q-icon" />
                <span>{faq.q}</span>
              </div>
              <ChevronDown size={18} className={`faq-chevron ${open === i ? 'rotated' : ''}`} />
            </button>
            {open === i && (
              <div className="faq-answer">{faq.a}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}
